import { CDMVersion } from '@/enums/CDMVersion';

export const CDM_VERSIONS = [
  //   {
  //     name: '5.0',
  //     value: CDMVersion.V5_0,
  //   },
  //   {
  //     name: '5.0.1',
  //     value: CDMVersion.V5_0_1,
  //   },
  //   {
  //     name: '5.1',
  //     value: CDMVersion.V5_1,
  //   },
  //   {
  //     name: '5.2',
  //     value: CDMVersion.V5_2,
  //   },
  {
    name: '5.3',
    value: CDMVersion.V5_3,
  },
  //   {
  //     name: '5.3.1',
  //     value: CDMVersion.V5_3_1,
  //   },
  {
    name: '5.4',
    value: CDMVersion.V5_4,
  },
  //   {
  //     name: '6.0',
  //     value: CDMVersion.V6_0,
  //   },
];

export const CDM_VERSIONS_MAP = {
  [CDMVersion.V5_0]: '5.0',
  [CDMVersion.V5_0_1]: '5.0.1',
  [CDMVersion.V5_1]: '5.1',
  [CDMVersion.V5_2]: '5.2',
  [CDMVersion.V5_3]: '5.3',
  [CDMVersion.V5_3_1]: '5.3.1',
  [CDMVersion.V5_4]: '5.4',
  [CDMVersion.V6_0]: '6.0',
};

export const parseCDMVersion = (version: string) => {
  return version.replace(/^V/, '').replace('_', '.');
};
